import script from "./BlockAuthorTimeCommentFire.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockAuthorTimeCommentFire.vue?vue&type=script&setup=true&lang=js"

import "./BlockAuthorTimeCommentFire.vue?vue&type=style&index=0&id=4aafeba4&lang=scss"

const __exports__ = script;

export default __exports__